<p>cstp-target-characteristics works!</p>
